import { ReactElement } from 'react';

import { useBoolean } from '@dreryk/react-common';

import { ConfidentialResourceAccessRequestSingle } from '../../ResourceTypeCell.types';

import { RevokeAccessModal } from './RevokeAccessModal';

type RevokeAccessModalOpenerRenderProps = {
   openModal: VoidFunction;
};

type RevokeAccessModalOpenerProps = {
   request: ConfidentialResourceAccessRequestSingle;
   children: (renderProps: RevokeAccessModalOpenerRenderProps) => ReactElement;
};

export const RevokeAccessModalOpener = (props: RevokeAccessModalOpenerProps): ReactElement => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? <RevokeAccessModal request={props.request} onClose={closeModal} /> : null}
      </>
   );
};
